import { createContext } from 'react';
import { kashika1Options } from "../components/Header/normal/config";
import { kashika2Options } from "../components/Header/normal/kashika2config";
import { kashika3Options } from "../components/Header/normal/kashika3config";
import { kashika4Options } from "../components/Header/normal/kashika4config";
import { kashika5Options } from "../components/Header/normal/kashika5config";
import { kashika6Options } from "../components/Header/normal/kashika6config";
import { kashika7Options } from "../components/Header/normal/kashika7config";
import { spotList } from "../components/Spot/register/config";
import tameikeJson from '../assets/tmp/tameike_lite.json';
import popupJson from '../assets/tmp/popup.json'
import { tmpAPI, tmptestAPI } from "../utils/api";

// =================================================================================================
// 初期ステート
let initialState = {
    spots: [], // 仮のスポットなので、不要になれば削除
    popups: popupJson, //　時系列データをここにセット タイムスライダーの長さに揃える
    currentPopup: {
        labels: [],
        datasets: []
    }, // ポップアップの対象スポット情報
    sliderTime: [],
    timeIdx: 11, // スライダーの値
    playAnimation: false, // スライダーの再生モード
    registerMode: false, // スポット登録モード
    regist: false, // 登録したスポットのチェックボックス
    newSpot: {
        category: null,
        latitude: null,
        longitude: null,
        name: null,
        memo: null
    },
    update:false,    
    menu:{
        "menu_97": false
    },
    opacity: 0.5,
    // 法規制のクリックされたレイヤー情報のstore
    clickedTileFeatureInfo: {
        id:[],
        properties:[]
    },
    clickedPointLatLng: [],
    // 法規制のポップアップ情報
    lawInfo: {} ,
    // 可視化4の注意事項ポップアップの表示有無
    isVis4PopupOpened:true,
};

// 可視化1
kashika1Options.map(outer_option=>outer_option.options.map(option=>initialState[option.id] = {
    checked: false,
    data: []
}));

// 可視化2
kashika2Options.map(outer_option=>outer_option.options.map(option=>initialState[option.id] = {
    checked: false,
    data: []
}));

// 可視化3
kashika3Options.map(outer_option=>outer_option.options.map(option=>initialState[option.id] = {
    checked: false,
    data: []
}));

// 可視化4
kashika4Options.map(outer_option=> {
    
   outer_option.options.map(option => {

      initialState[option.id] = {
          checked: false,
          isCheckedInModal: false,
          data   : []
      }
      
      // 設定で子レイヤーを設定している場合は子レイヤーについても初期化する。
      // ・法規制マップ - 森林法 
      if (option.hasChild) {
        option.subLayers.map(subLayerOption => {
        	initialState[subLayerOption.id] = {
        		checked: false,
        		data   : []
        	}
        })
      }

   })
 

});

// 可視化5
kashika5Options.map(outer_option=>outer_option.options.map(option=> {
    initialState[option.id] = {
        checked: false,
        isCheckedInModal: false,
        data: []
    }
}));

// 可視化6
kashika6Options.map(outer_option=>outer_option.options.map(option=>initialState[option.id] = {
    checked: false,
    data: []
}));

// 可視化7
kashika7Options.map(outer_option=>outer_option.options.map(option=>initialState[option.id] = {
    checked: false,
    data: []
}));

// 登録スポットから初期ステートを構築
spotList.map(category => initialState[category.type] = false)

// =================================================================================================

// =================================================================================================
// reducer
const reducer = (state, action) => {
    switch(action.type) {
        case 'TOGGLE_MODE':
            return {
                ...state,
                registerMode: !state.registerMode
            };
        case 'TOGGLE_CHECKED':
            return {
                ...state,
                [action.category]: {
                    ...state[action.category],
                    checked: !state[action.category].checked,
                }
            };
        case 'SET_CHECKED':
            return {
                ...state,
                [action.category]: {
                    ...state[action.category],
                    checked: action.show,
                }
            };
        case 'TOGGLE_MARKER_VISIBLE':
            if (action.category === 'regist') {
                spotList.map(category => state[category.type] = !state['regist']);
            }
            return {
                ...state,
                [action.category]: !state[action.category] 
             };
        case 'SET_MARKER_VISIBLE':
            if(action.visibility){
                return {
                    ...state,
                    [action.category]: action.visibility,
                    regist: true
                }
            }
            return {
                ...state,
                [action.category]: action.visibility
        }
        case 'SET_CURRENT_POPUP':
            return {
                ...state,
                currentPopup: action.payload
            };
        case 'SET_TIME_IDX':
            return {
                ...state,
                timeIdx: action.payload
            }
        case 'SET_PLAY_ANIMATION':
            return {
                ...state,
                playAnimation: action.payload
            }
        case 'SET_DATA':
            return {
                ...state,
                [action.category]: {
                    ...state[action.category],
                    data: action.payload,
                }
            }
        case 'SET_NEW_SPOT':
            return {
                ...state,
                "newSpot": {
                    category: action.category,
                    latitude: action.latitude,
                    longitude: action.longitude,
                    name: action.name,
                    memo: action.memo
                }
            }
        case 'SET_MENU':
            return {
                ...state,
                menu: action.payload
            }
        case 'MAP_UPDATE':
            return {
                ...state,
                update: !state.update
            }
        case 'SET_OPACITY':
            return {
                ...state,
                opacity: action.payload
            }
        case 'CLEAR_VLAYER_INFO':
            return {
                ...state,
                clickedTileFeatureInfo: {
                    id: [],
                    properties: []
                }
            }
        case 'SET_VLAYER_INFO':
            return {
                ...state,
                clickedTileFeatureInfo: {
                    id: [...state.clickedTileFeatureInfo.id, action.id],
                    properties: [...state.clickedTileFeatureInfo.properties, action.properties]
                }
            }
        case 'SET_VLAYER_LATLNG':
            return {
                ...state,
                clickedPointLatLng: [action.latlng.lat, action.latlng.lng]
            }
        case 'SET_90_LAW_DATA':
            // 法規制のデータセット情報
            return {
                ...state,
                data_for_90: {
                    data: action.payload,
                }
            }
        case 'SET_MODAL_AGREE':
            // モーダルでの同意が必要なメニューの汎用的な同意処理
            return {
                ...state,
                [action.category]: {
                    ...state[action.category],
                    isCheckedInModal: true,
                }
            };
        case 'SET_VIS93_MODAL_AGREE':
            // 各種法令の規制情報_建築基準法（指定道路図）での表示可否モーダルでの承認処理
            return {
                ...state,
                [action.category]: {
                    ...state[action.category],
                    isCheckedInModal: true,
                }
            };
        case 'SET_IS_VIS4_POPUP_OPENED':
            return {
                ...state,
                isVis4PopupOpened: action.payload
            };
        case 'SET_IS_EXPLANATION_POPUP_OPENED':
            // 注釈モーダルを表示するかどうかの汎用処理。ここでいうcategoryはvis_92などのid
            return {
                ...state,
                [action.category]: {
                    ...state[action.category],
                    showModal: action.payload,
                }
            };
        default:
            return state;
    }
};

const Context = createContext({});

export {
    initialState,
    reducer,
    Context
};
